import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkRideStatusDoneApproved = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkStatusDoneApprovedRidesProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkRideStatusDoneApproved,
    entity,
  );
  const bulkStatusDoneApprovedRidesProcess = useRecoilValue(
    activeProcessSF(bulkStatusDoneApprovedRidesProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkRideStatusDoneApproved,
      toastSummaryOnComplete: true,
      process: bulkStatusDoneApprovedRidesProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
    });
  }, [
    bulkStatusDoneApprovedRidesProcess,
    entity,
    onComplete,
    stopProcessPolling,
    t,
  ]);
};
